var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserTimes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 24,
    viewBox: "0 0 28 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 9.6C0 5.07452 0 2.81178 1.44101 1.40589C2.88202 0 5.20129 0 9.83984 0H12.2998C16.9383 0 19.2576 0 20.6986 1.40589C22.1396 2.81178 22.1396 5.07452 22.1396 9.6V12V14.4C22.1396 18.9255 22.1396 21.1882 20.6986 22.5941C19.2576 24 16.9383 24 12.2998 24H9.83984C5.20129 24 2.88202 24 1.44101 22.5941C0 21.1882 0 18.9255 0 14.4V9.6Z",
    fill: "url(#paint0_linear_3376_6574)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8798 2.81769C19.151 3.08901 19.151 3.52868 18.8798 3.79995L17.5287 5.151L18.8798 6.50206C19.151 6.77338 19.151 7.21305 18.8798 7.48432C18.6085 7.75559 18.1688 7.75551 17.8975 7.48432L16.5464 6.13326L15.1954 7.48432C14.9241 7.75559 14.4845 7.75551 14.2131 7.48432C13.9418 7.21301 13.9418 6.77337 14.2131 6.50206L15.5642 5.151L14.2131 3.79995C13.9418 3.52864 13.9418 3.089 14.2131 2.81769C14.4844 2.54638 14.9241 2.54638 15.1954 2.81769L16.5464 4.16874L17.8975 2.81769C18.1688 2.54638 18.6085 2.54638 18.8798 2.81769Z",
    fill: "#FFD7DF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.69824 15.0781C9.2791 15.0783 10.732 15.9478 11.4795 17.3408L12.0303 18.3672C12.2389 18.7563 12.093 19.2412 11.7041 19.4502C11.3148 19.659 10.829 19.5123 10.6201 19.123L10.0693 18.0967C9.60049 17.2233 8.68952 16.6779 7.69824 16.6777C6.70685 16.6778 5.79509 17.2232 5.32617 18.0967L4.77539 19.123C4.56652 19.5121 4.08156 19.6587 3.69238 19.4502C3.30332 19.2413 3.15666 18.7564 3.36524 18.3672L3.91699 17.3398C4.66467 15.9472 6.11754 15.0782 7.69824 15.0781Z",
    fill: "#FFD7DF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.69824 8.05859C9.36143 8.05895 10.7108 9.40708 10.7109 11.0703C10.7109 12.7337 9.36151 14.0827 7.69824 14.083C6.03479 14.0829 4.68653 12.7338 4.68653 11.0703C4.68666 9.40694 6.03487 8.05873 7.69824 8.05859ZM7.69824 9.6582C6.91852 9.65834 6.28627 10.2906 6.28613 11.0703C6.28613 11.8501 6.91844 12.4823 7.69824 12.4824C8.47785 12.4821 9.11035 11.85 9.11035 11.0703C9.11022 10.2907 8.47777 9.65856 7.69824 9.6582Z",
    fill: "#FFD7DF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3376_6574",
    x1: 3.53639,
    y1: 0.845291,
    x2: 18.0384,
    y2: 24.3235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD7E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA608C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserTimes);
export default __webpack_public_path__ + "static/media/user-times.3383868ba913565207298c9bcb4d020e.svg";
export { ForwardRef as ReactComponent };